import Axios from "../../Lib/Axios";
export const getOurTeams = () => {
    return Axios.get(`our-teams`);
}